module.exports = __webpack_public_path__ + "img/1-8.d286f9cd.png";